<div class="main-content table-page revision-bsc">
  <div class="container-fluid">
    <nav class="bsc-migas" aria-label="Ruta de navegación">
      <a [routerLink]="ruta.tablero" [queryParams]="{ anio: anio }" *ngIf="verTablero; else sinTablero">BSC</a>
      <ng-template #sinTablero><span>BSC</span></ng-template>
      <span aria-hidden="true">›</span>
      <span aria-current="page">Revisión BSC</span>
    </nav>

    <section class="table-page__hero">
      <div class="table-page__copy">
        <h1>{{ titulo }}</h1>
        <p *ngIf="estado === 'DATOS'">{{ resumen }}</p>
        <p *ngIf="estado !== 'DATOS'">
          Los cierres trimestrales que envían las áreas: se autorizan con PIN o se regresan con comentarios.
        </p>
      </div>

      <div class="table-page__toolbar-actions revision-bsc__acciones">
        <a mat-raised-button class="btn table-page__icon-btn table-page__icon-btn--secondary"
           *ngIf="verTablero && estado === 'DATOS'" [routerLink]="ruta.tablero" [queryParams]="queryTablero">
          <span class="material-icons" aria-hidden="true">dashboard</span>
          Ver tablero
        </a>
        <button type="button" mat-raised-button class="btn table-page__icon-btn table-page__icon-btn--secondary"
                *ngIf="puedeRecordar" [disabled]="recordando || loading" [attr.aria-busy]="recordando"
                (click)="recordar()">
          <span class="material-icons" aria-hidden="true">notifications_active</span>
          {{ recordando ? "Enviando…" : "Recordar a pendientes" }}
        </button>
      </div>
    </section>

    <app-selector-corte-bsc prefijo="bsc-rev" [mostrarCorte]="false" [anio]="anioInicial" [deshabilitado]="loading"
                            (cambio)="onSeleccion($event)">
      <div meta class="tickets-filter revision-bsc__filtro-trimestre" *ngIf="trimestre != null">
        <label for="bsc-rev-trimestre">Trimestre</label>
        <div class="tickets-select">
          <mat-icon aria-hidden="true">date_range</mat-icon>
          <select id="bsc-rev-trimestre" [disabled]="loading" (change)="cambiaTrimestre($event)">
            <option *ngFor="let q of trimestres" [value]="q" [selected]="q === trimestre">Q{{ q }} · {{ meses(q) }}</option>
          </select>
        </div>
      </div>
      <div meta class="tickets-toolbar__meta" *ngIf="estado === 'DATOS'">
        <span>{{ loading ? "Actualizando…" : resumenBarra }}</span>
        <strong>{{ cicloCerrado ? "Año cerrado" : limite ? "Límite de envío " + limite : "Sin fecha límite de envío" }}</strong>
      </div>
    </app-selector-corte-bsc>

    <!-- Lo que dejó «Recordar a pendientes». La región existe siempre: así se anuncia al llegar. -->
    <output class="revision-bsc__anuncio" aria-live="polite">
      <div class="bsc-franja revision-bsc__recordatorio" *ngIf="resultadoRecordar" tabindex="-1"
           [class.is-ok]="resultadoRecordar.ok">
        <span class="material-icons" aria-hidden="true">{{ resultadoRecordar.ok ? "notifications_active" : "info" }}</span>
        <div>
          <span>{{ resultadoRecordar.texto }}</span>
          <ul *ngIf="resultadoRecordar.avisos.length > 0">
            <li *ngFor="let a of resultadoRecordar.avisos; trackBy: trackTexto">{{ a }}</li>
          </ul>
        </div>
      </div>
    </output>

    <!-- ============================ Estados sin datos ============================ -->
    <section class="table-page__card revision-bsc__vacio" *ngIf="estado === 'CARGANDO'">
      <div class="table-page__empty">
        <span class="material-icons" aria-hidden="true">hourglass_top</span>
        <h3>Consultando la bandeja de revisión</h3>
        <p>Espere un momento.</p>
      </div>
    </section>

    <section class="table-page__card revision-bsc__vacio" *ngIf="estado === 'ERROR'">
      <div class="table-page__empty">
        <span class="material-icons" aria-hidden="true">lock_outline</span>
        <h3>No se pudo consultar la bandeja</h3>
        <p>{{ error }}</p>
        <button type="button" mat-raised-button class="btn table-page__primary-btn" (click)="consultar()">
          <span class="material-icons" aria-hidden="true">refresh</span>
          Volver a consultar
        </button>
      </div>
    </section>

    <section class="table-page__card revision-bsc__vacio" *ngIf="estado === 'SIN_CICLO'">
      <div class="table-page__empty">
        <span class="material-icons" aria-hidden="true">event_busy</span>
        <h3>{{ anio }} no tiene trimestres que revisar</h3>
        <p *ngFor="let a of avisos; trackBy: trackTexto">{{ a }}</p>
        <p *ngIf="avisos.length === 0">Calidad da de alta el año en Parámetros; después cada área planea sus metas.</p>
        <a mat-raised-button class="btn table-page__icon-btn table-page__icon-btn--secondary" *ngIf="puedeConfigurar"
           [routerLink]="ruta.parametros">
          <span class="material-icons" aria-hidden="true">tune</span>
          Ir a Parámetros
        </a>
      </div>
    </section>

    <!-- ============================ La bandeja ============================ -->
    <div class="revision-bsc__rejilla" *ngIf="estado === 'DATOS'">
      <section class="table-page__card revision-bsc__lista" aria-labelledby="revision-bsc-areas">
        <header class="revision-bsc__encabezado">
          <h2 id="revision-bsc-areas" class="bsc-oculto">Áreas de Q{{ trimestre }} {{ anio }}</h2>
          <fieldset class="revision-bsc__filtros" aria-label="Filtrar por estado">
            <button type="button" class="revision-bsc__filtro" *ngFor="let f of filtros; trackBy: trackFiltro"
                    [class.is-elegido]="f.valor === filtro" [attr.aria-pressed]="f.valor === filtro"
                    (click)="cambiaFiltro(f.valor)">
              {{ f.texto }} <span aria-hidden="true">·</span> {{ f.cuantos }}
            </button>
          </fieldset>
        </header>

        <div class="table-page__table-wrap" *ngIf="filasVisibles.length > 0; else sinFilas">
          <table class="table-page__table revision-bsc__tabla">
            <caption class="bsc-oculto">
              Áreas con planeación {{ anio }} autorizada en Q{{ trimestre }}, filtro «{{ textoFiltro }}». Elige una para
              ver su envío.
            </caption>
            <thead>
              <tr>
                <th scope="col">Área</th>
                <th scope="col">Estado</th>
                <th scope="col">Enviado</th>
                <th scope="col" class="revision-bsc__num">Alcance Q{{ trimestre }} <span class="bsc-oculto">de lo programado</span></th>
                <th scope="col" class="table-page__actions-head"><span class="bsc-oculto">Acciones</span></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let f of filasVisibles; trackBy: trackFila" class="is-clickable"
                  [class.is-selected]="f.id === seleccion" (click)="clicFila(f, $event)"
                  (keydown.enter)="$event.target === $event.currentTarget ? clicFila(f, $event) : null">
                <td>
                  <div class="table-page__cell-stack">
                    <strong class="table-page__name">{{ f.area }}</strong>
                    <span class="table-page__subtext" *ngIf="f.propio">Tuya: la autoriza otra persona</span>
                  </div>
                </td>
                <td>
                  <div class="table-page__cell-stack">
                    <span class="table-page__status-badge" [ngClass]="f.estado.clase">
                      <span class="material-icons" aria-hidden="true">{{ f.estado.icono }}</span>
                      {{ f.estado.texto }}
                    </span>
                    <span class="table-page__subtext" [class.revision-bsc__vencido]="f.estado.valor === 'SIN_ENVIAR'"
                          *ngIf="f.estadoNota">{{ f.estadoNota }}</span>
                  </div>
                </td>
                <td>
                  <div class="table-page__cell-stack">
                    <span class="table-page__text revision-bsc__quien">{{ f.enviadoPor }}</span>
                    <span class="table-page__subtext" *ngIf="f.enviadoCuando">{{ f.enviadoCuando }}</span>
                  </div>
                </td>
                <td class="revision-bsc__num">
                  <div class="table-page__cell-stack revision-bsc__alcance">
                    <strong>{{ f.alcance }}<span class="table-page__subtext" *ngIf="f.programado"> {{ f.programado }}</span></strong>
                    <span class="table-page__subtext revision-bsc__semaforo" *ngIf="f.diferencia"
                          [ngClass]="f.semaforo?.clase ?? ''">
                      <span class="material-icons" aria-hidden="true" *ngIf="f.semaforo">{{ f.semaforo.icono }}</span>
                      {{ f.diferencia }}
                    </span>
                  </div>
                </td>
                <td>
                  <button type="button" class="table-page__link revision-bsc__abrir" [attr.aria-label]="f.etiquetaAccion"
                          [attr.aria-current]="f.id === seleccion ? 'true' : null" (click)="abre(f)">
                    {{ f.porRevisar ? "Revisar" : "Ver" }}
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <ng-template #sinFilas>
          <div class="table-page__empty revision-bsc__sin-filas">
            <span class="material-icons" aria-hidden="true">{{ filas.length > 0 ? "filter_alt_off" : "inbox" }}</span>
            <ng-container *ngIf="filas.length > 0">
              <h3>Ninguna área en «{{ textoFiltro }}»</h3>
              <button type="button" class="table-page__link revision-bsc__abrir" (click)="cambiaFiltro('TODOS')">
                Ver todas las áreas
              </button>
            </ng-container>
            <ng-container *ngIf="filas.length === 0">
              <h3>Ninguna área tiene planeación {{ anio }} autorizada</h3>
              <p>Los trimestres se revisan sobre la planeación del año autorizada por Dirección.</p>
              <a class="table-page__link" *ngIf="verPlaneacion" [routerLink]="ruta.planeacion"
                 [queryParams]="{ anio: anio }">Ir a Planeación de metas</a>
            </ng-container>
          </div>
        </ng-template>

        <div class="bsc-mensajes bsc-mensajes--aviso revision-bsc__avisos" *ngIf="avisos.length > 0">
          <h3>
            <span class="material-icons" aria-hidden="true">info</span>
            Para tomar en cuenta
          </h3>
          <ul>
            <li *ngFor="let a of avisos; trackBy: trackTexto">{{ a }}</li>
          </ul>
        </div>

        <p class="revision-bsc__pie">
          Estados: En captura → Enviado → Autorizado, o Regresado (vuelve a captura con comentarios). Cada cambio guarda
          quién y cuándo. Los alcances autorizados quedan congelados; los demás se calculan en vivo.
        </p>
      </section>

      <div class="revision-bsc__lado">
        <p class="bsc-nota revision-bsc__oculta" *ngIf="seleccionOculta && filaSeleccionada">
          {{ filaSeleccionada.area }} ya no está en «{{ textoFiltro }}»; su envío sigue abierto aquí.
        </p>
        <app-detalle-envio-bsc [idEjercicioTrimestre]="seleccion" [renglon]="filaSeleccionada?.renglon ?? null"
                               [anio]="anio" (cambio)="onCambioDetalle($event)"></app-detalle-envio-bsc>
      </div>
    </div>
  </div>
</div>
